'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiTimes = function TiTimes(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm29 11c-1.3-1.3-3.4-1.3-4.7 0l-4.3 4.3-4.3-4.3c-1.3-1.3-3.4-1.3-4.7 0-1.3 1.3-1.3 3.4 0 4.7l4.3 4.3-4.3 4.3c-1.3 1.3-1.3 3.4 0 4.7 0.6 0.7 1.5 1 2.3 1s1.7-0.3 2.4-1l4.3-4.3 4.3 4.3c0.7 0.7 1.5 1 2.4 1s1.7-0.3 2.3-1c1.3-1.3 1.3-3.4 0-4.7l-4.3-4.3 4.3-4.3c1.3-1.3 1.3-3.4 0-4.7z' })
        )
    );
};

exports.default = TiTimes;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/times.js
// module id = 3803
// module chunks = 0